import {
  authAPI,
  usersAPI,
  companiesAPI,
  requestsAPI,
  quotesAPI,
  paymentsAPI,
  reportsAPI,
  messagesAPI,
  siteCustomizationAPI,
  dashboardAPI,
  notificationsAPI,
  missionsAPI,
  equipmentsAPI,
  serviceTypesAPI,
  productsAPI,
  invoicesAPI,
  kitsAPI,
  simulationAPI
} from './api';

// Le but de ce fichier est de fournir un point d'entrée unique et simple
// pour tous les services API, en mappant les implémentations détaillées
// du fichier `api.ts` vers des noms plus génériques et simples.

const apiService = {
  auth: authAPI,
  users: usersAPI,
  companies: companiesAPI,
  requests: requestsAPI,
  quotes: quotesAPI,
  payments: paymentsAPI,
  reports: reportsAPI,
  messages: messagesAPI,
  siteCustomization: siteCustomizationAPI,
  dashboard: dashboardAPI,
  notifications: notificationsAPI,
  missions: missionsAPI,
  equipments: equipmentsAPI,
  serviceTypes: serviceTypesAPI,
  products: productsAPI,
  invoices: invoicesAPI,
  kits: kitsAPI,
  simulation: simulationAPI,
};

export default apiService;